/**
 * Focus (next or prev) element
 *
 * @package ARS Webapp
 * @author René Schulze <schulze@thadeus-roth.de>
 */


/**
 * Focus (next or prev) element
 *
 * @param {HTMLElement} el   Reference element
 * @param {string}      mode Optional `next` or `prev` element focus
 *
 * @return {void}
 */
export const focusElement = (el, mode) => {
    const query = 'a[href], area[href], input, select, textarea, button, iframe, object, embed, [tabindex], [contenteditable]';
    const queryExclude = '*:not([tabindex="-1"], [disabled])';
    const elements = [...document.querySelectorAll(query)]
        .filter((element) => {
            return element.matches(queryExclude) && (element.offsetWidth > 0 || element.offsetHeight > 0);
        });
    let index = elements.indexOf(el);

    if (mode == 'next') {
        index++;
    } else if (mode == 'prev') {
        index--;
    }

    if (index == elements.length || index < 0) {
        index = 0;
    }

    elements[index].focus();
};
